import { faArrowRightLong } from '@fortawesome/pro-light-svg-icons';
import { faFileCode, faNoteSticky } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelopesBulk, faPaperclip } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import Grid from 'Components/Atoms/Grid/Grid';
import IconWrapper from 'Components/Atoms/IconWrapper/IconWrapper';
import StatusLabel from 'Components/Atoms/Label/StatusLabel/StatusLabel';
import Spinner from 'Components/Atoms/Spinner/Spinner';
import Text from 'Components/Atoms/Text/Text';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import Card from 'Components/Molecules/Card/Card';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import SettingsTemplate from 'Components/Templates/Page/Settings/SettingsTemplate';
import { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { ROUTES } from 'Services/Route/Route.types';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { fetchEntities } from 'Store/Settings/Entities/Actions';
import { getEntitiesById, isEntityLoading } from 'Store/Settings/Entities/Selectors';
import { fetchFields } from 'Store/Settings/Fields/Actions';
import { fetchModules } from 'Store/Settings/Modules/Actions';
import { isModulesFetching } from 'Store/Settings/Modules/Selectors';

const SettingsMenu: any = [{
    module: 'contact',
    path: ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.CONTACT_MODULE,
    icon: faEnvelopesBulk,
    title: 'Contactgegevens',
    description: 'Beschrijving'
}, {
    module: 'notes',
    path: ROUTES.SETTINGS.ENTITIES.ENTITY.FIELDS,
    icon: faPaperclip,
    title: 'Notities',
    description: 'Beschrijving'
}, {
    module: 'files',
    path: ROUTES.SETTINGS.ENTITIES.ENTITY.FIELDS,
    icon: faNoteSticky,
    title: 'Bestanden',
    description: 'Beschrijving'
}, {
    module: 'file_generator',
    path: ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.DOCUMENT_GENERATOR,
    icon: faFileCode,
    title: 'Document generator',
    description: 'Beschrijving'
}];

const ModulePage = ({
    isModulesFetching,
    entitiesById, isLoading,

    ...props
}: any) => {
    const { entity_id } = useParams();

    useEffect(() => {
        props.fetchFields();
        props.fetchEntities();
        props.fetchModules();
    }, []);

    const entity = useMemo(() => {
        if (entity_id) {
            return {
                ...entitiesById?.[entity_id],
                formattedName: EntityHelper.getDisplayValueByName(entitiesById?.[entity_id]?.name)
            };
        }

        return {};
    }, [entitiesById, entity_id]);

    return <SettingsTemplate
        breadcrumbs={
            <Breadcrumbs>
                <BreadcrumbItem path={ROUTES.SETTINGS.path}>Instellingen</BreadcrumbItem>
                <BreadcrumbItem path={ROUTES.SETTINGS.ENTITIES.getFullPath()}>Entiteiten</BreadcrumbItem>
                <BreadcrumbItem path={ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath(entity?.id)}>{entity?.formattedName || 'Oops...'}</BreadcrumbItem>
                <BreadcrumbItem>Modules</BreadcrumbItem>
            </Breadcrumbs>
        }
        description={`Instellingen voor ${(entity?.formattedName || 'oops...')}`}
    >
        { isLoading &&
            <Grid position='centered'>
                <Spinner />
                <Title size='small' weight='semibold'>Entiteiten laden...</Title>
            </Grid>
        }
        { !isLoading
        && !entity?.id
        &&  <Grid position='centered'>
                <Title size='small' weight='semibold'>Geen entiteit gevonden met de volgende id: {entity_id}</Title>
            </Grid>
        }
        { !isLoading
            && entity?.id
            && <Grid axis='vertical'>
                {
                    SettingsMenu.map((i: any) =>
                        <Link to={i.path.getFullPath(entity_id)} style={{textDecoration: 'none'}} key={entity_id} data-cy="entity-item">
                            <Card axis="horizontal" state="link">
                                <TitleGroup iconBefore={
                                    <IconWrapper>
                                        <FontAwesomeIcon icon={i.icon} size="2x" />
                                    </IconWrapper>
                                }>
                                    <Grid gap='small' axis='horizontal' align='center'>
                                        <Title
                                            size="inherit"
                                            transform='uppercase'
                                            weight='bold'
                                        >
                                            { i.title }
                                        </Title>
                                        <StatusLabel
                                            status={!!entity.modules?.[i.module]
                                                ? 'active'
                                                : 'inactive'
                                            }>
                                                {
                                                    !!entity.modules?.[i.module]
                                                    ? 'Ingeschakeld'
                                                    : 'Uitgeschakeld'
                                                }
                                        </StatusLabel>
                                    </Grid>
                                    <Text color='secondary'>{i.description}</Text>
                                </TitleGroup>
                                <FontAwesomeIcon icon={faArrowRightLong} size='2x' color='#757575' />
                            </Card>
                        </Link>
                    )
                }
            </Grid>
        }
    </SettingsTemplate>
}

export default connect(
    (state: any) => ({
        isModulesFetching: isModulesFetching(state),

        entitiesById: getEntitiesById(state),
        isLoading: isEntityLoading(state)
    }), {
        fetchEntities,
        fetchModules,
        fetchFields
    }
)(ModulePage);